<template>
    <div class="menu_con flex_clumn">
        <div class="title_logo">
            <el-image class="titLogo" :src="logoImg"></el-image>
        </div>
        <div class="menu_con_bg">
            <div class="menu_con_item">
                <div class="menu_item flex_center">
                    <div :class="navselected === 'home' ? 'menu_item_li menu_item_li_active flex_center':'menu_item_li flex_center'" @click="changeData('home')">
                        <div class="item_left flex_c_left">
                            <el-icon><platform /></el-icon>
                            <span>工作台</span>
                        </div>
                        <div class="item_right flex_center"></div>
                    </div>
                </div>
                <div class="menu_item flex_center flex_c_col">
                    <div :class="navselected === 'clinictreat' || navselected === 'order'
                     || navselected === 'detail' ? 'menu_item_li_child menu_item_li_child_active flex_center':'menu_item_li_child flex_center'" @click="changeData('clinictreat')">
                        <div class="item_left flex_c_left">
                            <el-icon><HomeFilled /></el-icon>
                            <span>门诊接诊</span>
                        </div>
                        <div class="item_right flex_center">
                            <span v-if="navselected !== 'clinictreat' && navselected !== 'order' && navselected !== 'detail'"><el-icon><ArrowRightBold /></el-icon></span>
                            <span v-if="navselected === 'clinictreat' || navselected === 'order' || navselected === 'detail'"><el-icon><ArrowDownBold /></el-icon></span>
                        </div>
                    </div>
                    <div class="menu_item_child_con flex_center flex_c_col" v-if="navselected === 'clinictreat' || navselected === 'order' || navselected === 'detail'">
                        <div class="menu_item_child flex_c_right" @click="changeData('clinictreat')">
                            <div :class="navselected === 'clinictreat' ? 'menu_item_child_li menu_item_child_li_act flex_center':'menu_item_child_li flex_center'">
                                <el-icon class="mrr5"><HomeFilled /></el-icon>
                                <span>接诊开方</span>
                            </div>
                        </div>
                        <div class="menu_item_child flex_c_right" @click="changeData('order')">
                            <div :class="navselected === 'order' || navselected === 'detail' ? 'menu_item_child_li menu_item_child_li_act flex_center':'menu_item_child_li flex_center'">
                                <el-icon class="mrr5"><List /></el-icon>
                                <span>门诊订单</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="menu_item flex_center flex_c_col">
                    <div :class="navselected === 'treatment' || navselected === 'treatorder' ? 'menu_item_li_child menu_item_li_child_active flex_center':'menu_item_li_child flex_center'" @click="changeData('treatment')">
                        <div class="item_left flex_c_left">
                            <el-icon><Stamp /></el-icon>
                            <span>检查治疗</span>
                        </div>
                        <div class="item_right flex_center">
                            <span v-if="navselected !== 'treatment' && navselected !== 'treatorder'"><el-icon><ArrowRightBold /></el-icon></span>
                            <span v-if="navselected === 'treatment' || navselected === 'treatorder'"><el-icon><ArrowDownBold /></el-icon></span>
                        </div>
                    </div>
                    <div class="menu_item_child_con flex_center flex_c_col" v-if="navselected === 'treatment' || navselected === 'treatorder'">
                        <div class="menu_item_child flex_c_right" @click="changeData('treatment')">
                            <div :class="navselected === 'treatment' ? 'menu_item_child_li menu_item_child_li_act flex_center':'menu_item_child_li flex_center'">
                                <el-icon class="mrr5"><Stamp /></el-icon>
                                <span>诊疗开单</span>
                            </div>
                        </div>
                        <div class="menu_item_child flex_c_right" @click="changeData('treatorder')">
                            <div :class="navselected === 'treatorder' ? 'menu_item_child_li menu_item_child_li_act flex_center':'menu_item_child_li flex_center'">
                                <el-icon class="mrr5"><Flag /></el-icon>
                                <span>诊疗订单</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="menu_item flex_center flex_c_col">
                    <div :class="navselected === 'reservation' || navselected === 'consultationcall' ? 'menu_item_li_child menu_item_li_child_active flex_center':'menu_item_li_child flex_center'" @click="changeData('reservation')">
                        <div class="item_left flex_c_left">
                            <el-icon><checked /></el-icon>
                            <span>预约管理</span>
                        </div>
                        <div class="item_right flex_center">
                            <span v-if="navselected !== 'reservation' && navselected !== 'consultationcall'"><el-icon><ArrowRightBold /></el-icon></span>
                            <span v-if="navselected === 'reservation' || navselected === 'consultationcall'"><el-icon><ArrowDownBold /></el-icon></span>
                        </div>
                    </div>
                    <div class="menu_item_child_con flex_center flex_c_col" v-if="navselected === 'reservation' || navselected === 'consultationcall'">
                        <div class="menu_item_child flex_c_right" @click="changeData('reservation')">
                            <div :class="navselected === 'reservation' ? 'menu_item_child_li menu_item_child_li_act flex_center':'menu_item_child_li flex_center'">
                                <el-icon class="mrr5"><checked /></el-icon>
                                <span>预约列表</span>
                            </div>
                        </div>
                        <div class="menu_item_child flex_c_right" @click="changeData('consultationcall')">
                            <div :class="navselected === 'consultationcall' ? 'menu_item_child_li menu_item_child_li_act flex_center':'menu_item_child_li flex_center'">
                                <el-icon class="mrr5"><Ticket /></el-icon>
                                <span>叫号问诊</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="menu_item flex_center" v-if="sysName !== '18638170882'">
                    <div :class="navselected === 'patient' ? 'menu_item_li menu_item_li_active flex_center':'menu_item_li flex_center'" @click="changeData('patient')">
                        <div class="item_left flex_c_left">
                            <el-icon><user-filled /></el-icon>
                            <span>病例管理</span>
                        </div>
                        <div class="item_right flex_center"></div>
                    </div>
                </div>
                <div class="menu_item flex_center" v-if="sysName === '18638170882'">
                    <div :class="navselected === 'patientlist' ? 'menu_item_li menu_item_li_active flex_center':'menu_item_li flex_center'" @click="changeData('patientlist')">
                        <div class="item_left flex_c_left">
                            <el-icon><user-filled /></el-icon>
                            <span>病例管理</span>
                        </div>
                        <div class="item_right flex_center"></div>
                    </div>
                </div>
                <div class="menu_item flex_center">
                    <div :class="navselected === 'performance' ? 'menu_item_li menu_item_li_active flex_center':'menu_item_li flex_center'" @click="changeData('performance')">
                        <div class="item_left flex_c_left">
                            <el-icon><histogram /></el-icon>
                            <span>绩效分析</span>
                        </div>
                        <div class="item_right flex_center"></div>
                    </div>
                </div>
                <div class="menu_item flex_center">
                    <div :class="navselected === 'prescription' ? 'menu_item_li menu_item_li_active flex_center':'menu_item_li flex_center'" @click="changeData('prescription')">
                        <div class="item_left flex_c_left">
                            <el-icon><Management /></el-icon>
                            <span>处方模版</span>
                        </div>
                        <div class="item_right flex_center"></div>
                    </div>
                </div>
            </div>

            <div class="menu_item_bottom flex_center">
                <div class="menu_item_li flex_center" @click="logout()">
                    <el-icon><switch-button /></el-icon>
                    <span style="letter-spacing: 3px">退出登录</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SidemenJs from "@/assets/scripts/components/sidemenu.js";
    export default SidemenJs;
</script>

<style scoped lang="scss">
    @import "@/assets/styles/admin";
</style>
